export function formatLocalDigits(localDigits: string): string {
  const d = localDigits.replace(/\D/g, '').slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)} ${d.slice(2)}`;
  return `${d.slice(0, 2)} ${d.slice(2, 5)} ${d.slice(5)}`;
}

export function parseLocalMobileInput(raw: string): string {
  let digits = raw.replace(/\D/g, '');
  if (digits.startsWith('60')) digits = digits.slice(2);
  return digits.slice(0, 11);
}

export function displayFullMalaysiaMobile(localDigits: string): string {
  const f = formatLocalDigits(localDigits);
  if (!f) return '+60';
  return `+60 ${f}`;
}
